import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect, InputControls, ApplyToAllButton } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';

const AccountingClassInput: InputWithSource = ({ input }) => (
    <GenericSelect
        label={input.name}
        input={input}
        topRightNode={<InputControls input={input} additionalLeftNode={<ApplyToAllButton input={input} />} />}
    />
);

AccountingClassInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(AccountingClassInput);
